import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { pointerIcon } from '../../icons';
import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';
import { AppContext } from '../../../../../../../../../AppModulesWrapper';

export const PriceEmpty = () => {
  const { webview } = React.useContext(AppContext);

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('price-empty-client-error-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ErrorWrapper icon={pointerIcon}>
      Введите цену объекта, чтобы увидеть, на какой странице поиска будет объявление
    </ErrorWrapper>
  );
};
